/**
 * SeminarFuture
 */
export default class SeminarFuture {

    // constructor
    constructor(selector) {
        let _this = this;
        this.$plugin = $(selector);
        if (this.$plugin.length === 0) {
            return false;
        }
        this.$result = this.$plugin.find('[data-tncp-plugin-seminarfuture="result"]');
        this.init();

    }

    init() {
        let vm = this;
        vm.getResults();

        // on form submit
        vm.$plugin.on('submit', '[data-tncp-plugin-seminarfuture="filterForm"]', () => {
            vm.getResults();
            return false;
        });
    }

    getResults() {
        let vm = this;
        return new Promise(function(resolve, reject) {
            let $form = vm.$plugin.find('[data-tncp-plugin-seminarfuture="filterForm"]');
            vm.request = window.xhrRequest({
                url: $form.attr('action'),
                method: 'POST',
            });
            vm.request.then((response) => {
                vm.$result.html(response.data.content);

                var $stickyTimeline = $('.js-timeline__sticky');
                $stickyTimeline.css('width', $stickyTimeline.parent().width()).fixedsticky();
                $(window).resize(function() {
                    $stickyTimeline.css('width', $stickyTimeline.parent().width());
                });
                $('.fixedsticky-dummy').css('display', 'none');

            }).catch((e) => {
                reject(e);
            });
        });
    }
}

